import Vue from "vue";
import "virtual:uno.css";
import "virtual:svg-icons-register";

// import { setupApp } from "wujie";

// 移动端开启rem自适应,px需要改为rem
import "@/utils/flexible.js";
import "@vant/touch-emulator";

import "animate.css";
import App from "./App.vue";
import routes from "./router";
import VueRouter from "vue-router";
import store, { setStore } from "./store";
import "@/styles/font-style.scss"; // 分格样式文件
import SvgIcon from "@/components/SvgIcon/index.vue";

import "./assets/main.css";

import "@ty/config_center";
// import Dialog from "vant/lib/dialog";
import "vant/lib/toast/index.less";
import "vant/lib/dialog/index.less";
import { isFunction } from "lodash-es";
import { initPermission } from "@/permission";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

// 全屏loading效果
import FullScreenLoadingIndex from "@/components/fullScreenLoading/fullScreenLoadingIndex.js";
import { Toast } from "@/utils/app";
// 引入字体样式
import "@/assets/font/DingTalk/DingTalk.css";

// WangEditor
import { Boot } from "@wangeditor/editor";
import regeneration from "@/views/intelligentAIWriting/components/wangEditorPlugInRegeneration.js";
Boot.registerMenu(regeneration);

import VueScrollTo from "vue-scrollto";
import URI from "urijs";
import { PageJumpType } from "@/enum/PageJumpType";

import "@/styles/common.scss";

Vue.use(VueScrollTo);

Vue.use(FullScreenLoadingIndex);

Vue.use(ElementUI);

Vue.config.errorHandler = (err) => {
  console.error(err);
  if (
    err?.code === "ERR_CANCELED" ||
    err?.message?.includes("此报错可以忽略")
  ) {
    return;
  }
  if (err.message) {
    Toast.fail(err.message);
  }
};
Vue.config.productionTip = false;
Vue.component("SvgIcon", SvgIcon);
Vue.prototype.$message = Toast;
Vue.prototype.$dialog = Toast;
Vue.prototype.$onBack = function (callback) {
  if (!isFunction(callback)) return;
  this.$watch("$route", (to, from) => {
    if (to.params["stack-key-dir"] === PageJumpType.back.value) {
      callback(from);
    }
  });
};

if (import.meta.env.DEV) {
  const initVconsole = async () => {
    if (!import.meta.env.VITE_ENABLE_VCONSOLE) return;
    const { default: VConsole } = await import("vconsole");
    new VConsole();
  };
  initVconsole();
  if (import.meta.env.VITE_DEVTOOLS_URL) {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = import.meta.env.VITE_DEVTOOLS_URL;
    document.head.appendChild(script);
  }
}

const { tycom } = window;
tycom.configCenter.registerEvent("onchange", () => {
  // console.log("onchange");
});
const initConfigPromise = new Promise((resolve, reject) => {
  tycom.configCenter.registerEvent("onload", resolve);
  tycom.configCenter.registerEvent("onerror", (e) => {
    reject(e || new Error("注册失败"));
  });
});

window.tycom._initConfigPromise = initConfigPromise;
/*
 * 微应用配置开始
 */
let router = null;
let instance = null;

function render(props = {}) {
  let propsObj = props;
  if (window.$wujie?.props) {
    propsObj = window.$wujie?.props;
  }
  if (window.$wujie?.bus) {
    if (propsObj.name) {
      window.$wujie?.bus.$on("sizeChange", (size) => {
        store.dispatch("setSize", size);
      });
      window.$wujie?.bus.$on(`${propsObj.name}Reload`, (name) => {
        store.dispatch("reload", name);
      });
      window.$wujie?.bus.$on(`setKeepList`, (params) => {
        const { visitedViews } = params;
        if (visitedViews) {
          const visitedViewsList = visitedViews.filter((item) => {
            return item?.meta?.appName === propsObj.name;
          });
          const _keepList = visitedViewsList.map((item) => {
            return item?.name;
          });
          store.dispatch("setKeepList", _keepList);
        }
      });
      window.$wujie?.bus.$on(`${propsObj.name}routerPush`, (params) => {
        const { props: propsObj } = params;
        const {
          defaultPath,
          store: parentStore,
          parentVm,
          getCurrentUserSetting,
        } = propsObj;
        if (parentStore) {
          setStore(parentStore);
        }
        setPrototype(propsObj);

        if (getCurrentUserSetting?.()?.size) {
          store.dispatch("setSize", getCurrentUserSetting?.().size);
        }
        if (
          parentVm?.$children?.push &&
          !parentVm?.$children.includes(instance)
        ) {
          parentVm?.$children?.push?.(instance);
        }
        if (defaultPath) {
          if (router.app._route.path === defaultPath) {
            // store.dispatch("reload", true);
          } else {
            router.push({ path: defaultPath }, () => {});
          }
        }
      });
    }
  }
  const {
    defaultObj,
    container,
    store: parentStore,
    parentVm,
    _id,
    getCurrentUserSetting,
  } = propsObj;
  // 第一次初始化时尝试从地址中获取
  const defaultPath =
    propsObj.defaultPath || URI(window.location.href).fragment() || "/";
  if (parentStore) {
    setStore(parentStore);
  }
  setPrototype(propsObj);

  if (getCurrentUserSetting?.()?.size) {
    store.dispatch("setSize", getCurrentUserSetting?.().size);
  }
  let mode = "abstract";
  // let mode = "hash";
  // if (import.meta.env.DEV) {
  //   mode =
  //     !window.__POWERED_BY_QIANKUN__ && !window.__POWERED_BY_WUJIE__
  //       ? "hash"
  //       : "abstract";
  // }
  router = new VueRouter({
    mode,
    routes,
  });
  // Vue.use(VuePageStack, { router });
  initPermission(router);

  if (
    window.__POWERED_BY_QIANKUN__ &&
    window.__CACHE_INSTANCE_BY_QIAN_KUN_FOR_VUE__ &&
    _id && //主应用必须传递id并且id与缓存中的id匹配时，才启用缓存
    window.__CACHE_INSTANCE_BY_QIAN_KUN_FOR_VUE__._id === _id
  ) {
    const cachedInstance = window.__CACHE_INSTANCE_BY_QIAN_KUN_FOR_VUE__;

    // 从最初的Vue实例上获得_vnode
    const cachedNode =
      // (cachedInstance.cachedInstance && cachedInstance.cachedInstance._vnode) ||
      cachedInstance._vnode;

    // 让当前路由在最初的Vue实例上可用
    router.apps.push(...cachedInstance.$router.apps);

    instance = new Vue({
      router,
      store: parentStore || store,
      render: () => cachedNode,
    });

    // 缓存最初的Vue实例
    instance.cachedInstance = cachedInstance;

    router.onReady(() => {
      const { fullPath } = router.currentRoute;
      const { fullPath: oldFullPath } = cachedInstance.$router.currentRoute;
      // 当前路由和上一次卸载时不一致，则切换至新路由
      if (fullPath !== oldFullPath) {
        cachedInstance.$router.push(fullPath);
      }
    });
    instance.$mount(
      container ? container.querySelector("#microApp") : "#microApp"
    );
  } else {
    // 正常实例化
    instance = new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount(container ? container.querySelector("#microApp") : "#microApp");
    instance._id = _id;
  }
  if (defaultPath) {
    if (defaultObj) {
      Vue.prototype._iconPath = defaultObj.iconPath;
      Vue.prototype._title = defaultObj.title;
    }
    router.push(defaultPath);
    if (defaultObj?.name) {
      store.dispatch("setKeepList", [defaultObj?.name]);
    }
  }
  // }
  if (import.meta.env.DEV) {
    // vue-devtools  加入此处代码即可
    if (parentVm?.$children?.push) {
      parentVm?.$children?.push?.(instance);
    } else {
      const instanceDiv = document.createElement("div");
      instanceDiv.__vue__ = instance;
      document.body.appendChild(instanceDiv);
    }
  }
}
// 独立运行时
if (!window.__POWERED_BY_QIANKUN__) {
  render();
}

export async function bootstrap() {
  // console.log("[vue] vue app bootstraped");
}
export function mount(props) {
  // console.log("[vue] props from main framework", props);
  render(props);
}
export function update(props) {
  // console.log("[vue] props from main framework", props);
  render(props);
}

export function unmount() {
  const cachedInstance = instance.cachedInstance || instance;
  window.__CACHE_INSTANCE_BY_QIAN_KUN_FOR_VUE__ = cachedInstance;
  const cachedNode = cachedInstance._vnode;
  // 让keep-alive可用
  cachedNode.data.keepAlive = true;
  cachedNode.data.hook.destroy(cachedNode);
  if (instance.cachedInstance) {
    instance.$destroy();
    instance = null;
  }
  router = null;
}

function setPrototype(propsObj) {
  const {
    onGlobalStateChange,
    setGlobalState,
    openFormDialog,
    openConfirm,
    openMessage,
    openDialog,
    openLoading,
    closeLoading,
    extend,
    againLoging,
    getCurrentUser,
    iconPath,
    reLoginFun,
    openTabsFormDialog,
    openMessageBox,
    getCurrentUserSetting,
    route,
  } = propsObj;
  Vue.prototype.$onGlobalStateChange = onGlobalStateChange;
  Vue.prototype.$setGlobalState = setGlobalState;
  Vue.prototype.$openFormDialog = openFormDialog;
  Vue.prototype.$openTabsFormDialog = openTabsFormDialog;
  Vue.prototype.$openTabsFormDialog = getCurrentUser;
  Vue.prototype.$openConfirm = openConfirm;
  Vue.prototype.$openMessage = openMessage;
  Vue.prototype.$openDialog = openDialog;
  Vue.prototype.$openMessageBox = openMessageBox;
  Vue.prototype.$openLoading = openLoading;
  Vue.prototype.$closeLoading = closeLoading;
  Vue.prototype.$extend = extend || {};
  Vue.prototype._iconPath = iconPath;
  Vue.prototype.$againLoging = againLoging;
  Vue.prototype.$reLoginFun = reLoginFun || {};
  Vue.prototype.$getCurrentUserSetting = getCurrentUserSetting || {};
  Vue.prototype.$QianKunRoute = route;
  Vue.prototype._title = null;
}
/*
 * 微应用配置结束
 */
